import React from 'react';
import PropTypes from 'prop-types';

const CheckboxIcon = ({ width, height, fill }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20">
        <path d="M10 0a10 10 0 1010 10A10 10 0 0010 0zM8.368 14.167l-3.75-3.6 1.163-1.2 2.567 2.448L14.2 5.833l1.185 1.174-7.017 7.16z" fill={fill}/>
    </svg>
);

CheckboxIcon.propTypes = {
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    fill: PropTypes.string
};

CheckboxIcon.defaultProps = {
    width: '20',
    height: '20',
    fill: '#4b254e'
};

export default CheckboxIcon;